// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1238":"4a1a79285cef3dc0","2403":"fd3c5fadb8d46dcf"}[chunkId] + ".js";
};